import { PaymentService } from "@/api";
import { useMutation } from "@tanstack/react-query";

export const useValidateQrPayment = () => {
    const result = useMutation({
        mutationFn: ({ transactionId }: { transactionId: string }) => PaymentService.paymentControllerValidatePayment({ transactionId }),
    });

    return result;
}